<template>
	<modal-dialog
		:modal-visible="visible"
		:title="title"
		confirm-button-text="Save"
		:submit-visible="hasModulePermWrite('Materials')"
		v-on:confirm="save"
		v-on:closeModal="closeModal">

		<field label="Supplier" 
			col-class="col-sm-4" 
			:params="{type: 'select',options:suppliersOptions}" 
			v-model="payload.supplier_id">
		</field>

		<field label="Category" 
			col-class="col-sm-4" 
			:params="{type: 'static'}" 
			:value='categoryName'>	
		</field>

		<field label="Part Number" 
			col-class="col-sm-4" 
			v-model="payload.part_number">
		</field>

		<field label="Supplier Part Number" 
			col-class="col-sm-4" 
			v-model="payload.supplier_number">
		</field>

		<field label="Description" 
			col-class="col-sm-4" 
			v-model="payload.description">
		</field>

		<field label="Manufacturer" 
			col-class="col-sm-4" 
			v-model="payload.manufacturer">
		</field>

		<field label="Per" 
			col-class="col-sm-4" 
			:params="{type:'number',step: 1,min:1,placeholder: 'ex. 1, 100, 1000'}" 
			v-model="payload.per">
		</field>

		<field label="Unit" 
			col-class="col-sm-4" 
			:params="{type:'select',options: $store.unitMeasurementOptions}" 
			v-model="payload.material_unit_type">
		</field>

		<field label="Trade Price $" 
			col-class="col-sm-4" 
			:params="{type:'number',min:0,step:0.01,placeholder:'0.00'}" 
			v-model="payload.material_price">
		</field>

		<!--<field label="Labour Per" 
			col-class="col-sm-4" 
			:params="{type:'select',options:unitOptions}" 
			v-model="payload.labour_per">
		</field>-->

		<field label="Labour (hrs/unit/per)" 
			col-class="col-sm-4" 
			:params="{type:'number',min:0,step:0.001,placeholder:'0.00'}" 
			v-model="payload.labour_hrs">
		</field>

		<button v-if="hasModulePermWrite('Materials')" slot="footer" class="btn btn-outline-danger" type="button" v-on:click="deleteModalVisible = true">
			<i class="fa fa-trash"></i>
			Delete Material
		</button>

		<modal-dialog
			:modal-visible="deleteModalVisible"
			title="Delete Material"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"
			v-on:confirm="deleteMaterial"
			v-on:closeModal="deleteModalVisible = false">

			Are you sure you want to delete this material?
		</modal-dialog>

	</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
	
export default {
	name: "MaterialEditModal",
	components: {
		ModalDialog,
		Field
	},
	props: ["visible","title","record","currentCategory"],
	data() {
		return {
			payload: {},
			suppliers: [],
			unitOptions: [{text:  'E (1)',value:1},{text:  'C (100)',value:100},{text:  'M (1000)',value:1000}],
			unitMeasurementOptions: [],
			deleteModalVisible: false
		}
	},
	watch: {
		record() {
			this.payload = this.record
		}
	},
	computed: {
		suppliersOptions() {
			let vm = this

			return this.optionify(this.suppliers,"name")
		},
		categoryName() {
			if ("MaterialCategory" in this.record && this.record.MaterialCategory)
				return this.record.MaterialCategory.name
			else if (!("id" in this.record) && this.currentCategory)
				return this.currentCategory.name
			else
				return ""
		}
	},
	methods: {
		closeModal() {
			this.$emit("closeModal")
		},
		save() {
			let vm = this

			let payload = this.cloneObj(this.payload)

			let fieldsToKeep = [
				"id","slug","tenant_id","supplier_id","category_id","description","part_number","per","material_unit_type","material_price","labour_hrs","comments","supplier_number","manufacturer"
			]

			Object.keys(payload).forEach(key => {
				if (fieldsToKeep.indexOf(key) == -1)
					delete payload[key]
			})

			this.saveRecord("Material",payload,response => {
				vm.alertSaved("Material saved")
				vm.$emit("closeModal")
				vm.$emit("modelChanged")
			})
		},
		deleteMaterial() {
			let vm = this

			this.postData("Material/delete",{id: this.record.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Material deleted")

					vm.deleteModalVisible = false
					vm.$emit("modelChanged")
				}
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let supplierParams = {
				filters: [["is_supplier",1]]
			}

			let promises = [
				this.getJSON("Contact/get",supplierParams),
			]

			if (vm.$store.unitMeasurementOptions.length == 0)
				promises.push(this.getJSON("Material/units"))

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.suppliers = responses[0].data

				if (responses.length == 2)
					vm.$store.unitMeasurementOptions = responses[1].data
			})
		}
	},
	created() {
		if (this.record)
			this.payload = this.record

		this.fetchData()
	}
}	
</script>